import { createConfig, fallback, http } from 'wagmi';
import { mainnet, sepolia, localhost, abey, polygon } from 'wagmi/chains';
import { metaMask } from '@wagmi/connectors';
import { vcityNetwork, hardhatLocalhost, rechargeNetwork } from './networkConfig';

import * as chains from 'wagmi/chains';

const { POLYGON_NETWORK_KEY } = process.env; // 环境参数

// 手动扩展 localhost 链的配置（解决默认配置可能不匹配的问题）
//   // 本地 合约地址
// export const hardhatLocalhost = {
//     ...localhost,
//     id: 31337, // Hardhat 本地节点固定 ChainID
//     name: 'Hardhat Localhost',
//     nativeCurrency: {
//         decimals: 18,
//         name: 'Ether',
//         symbol: 'ETH',
//     },
//     rpcUrls: {
//         default: {
//             http: ['http://127.0.0.1:8545'], // 明确指向本地 RPC 地址
//             webSocket: ['ws://127.0.0.1:8545'],
//         },
//         public: {
//             http: ['http://127.0.0.1:8545'],
//         },
//     },
// };

// const  mapVcityNetwork = {

// }

// export const vcityNetwork = {
//     ...localhost,
//     id: 20230826, // Hardhat 本地节点固定 ChainID
//     name: 'vcityNetwork',
//     nativeCurrency: {
//         decimals: 18,
//         name: 'Ether',
//         symbol: 'ETH',
//     },
//     rpcUrls: {
//         default: {
//             http: ['https://testnet-rpc.vcity.app'], // 明确指向本地 RPC 地址
//             webSocket: ['ws://testnet-rpc.vcity.app/ws'],
//         },
//         public: {
//             http: ['https://testnet-rpc.vcity.app'],
//         },
//     },
// };

export { vcityNetwork, hardhatLocalhost, rechargeNetwork };

// debugger;

export const config = createConfig({
    chains: [
        {
            ...mainnet,
            rpcUrls: {
                default: {
                    http: [
                        'https://cloudflare-eth.com', // ✅ 首选：永久免费、无密钥、无CORS
                        'https://eth.llamarpc.com', // ✅ 备用：同等级免费节点
                        'https://rpc.ankr.com/eth',
                        'https://eth.merkle.io',
                    ],
                }, // 首选（免费、无CORS、无限流）
                // 备用：['https://rpc.ankr.com/eth'] / ['https://eth.llamarpc.com']
            },
        },
        {
            ...polygon,
            rpcUrls: {
                default: {
                    http: [
                        'https://cloudflare-eth.com', // ✅ 首选：永久免费、无密钥、无CORS
                        'https://eth.llamarpc.com', // ✅ 备用：同等级免费节点
                        'https://rpc.ankr.com/eth',
                        'https://eth.merkle.io',
                    ],
                }, // 首选（免费、无CORS、无限流）
                // 备用：['https://rpc.ankr.com/eth'] / ['https://eth.llamarpc.com']
            },
        },

        // mainnet,
        sepolia,
        abey,
        hardhatLocalhost,
        vcityNetwork,
    ],
    // 本地合约测试
    // connectors: [
    //     metaMask({
    //         // 关键：强制钱包切换到本地链
    //         // targetChains: [hardhatLocal],
    //         // 允许未验证的链（本地链无官方验证）
    //         shimDisconnect: true,
    //         shimChainChangedDisconnect: false,
    //     }),
    // ],
    // 设置默认链为 Sepolia 2.   指定默认连接的网络（核心配置项）
    // defaultChain: sepolia,
    transports: {
        [polygon.id]: http(`https://polygon-mainnet.g.alchemy.com/v2/${POLYGON_NETWORK_KEY}`), // 1
        [mainnet.id]: http(), // 1
        [sepolia.id]: http(), //11155111
        [abey.id]: http(), // 179
        // [localhost.id]: http("http://127.0.0.1:8545"), // 必须和 Hardhat 节点端口一致
        // 本地 合约地址
        [hardhatLocalhost.id]: fallback([
            http(hardhatLocalhost.rpcUrls.default.http[0], {
                timeout: 10000, // 延长超时时间，避免本地节点响应慢导致连接失败
            }),
        ]),

        [vcityNetwork.id]: fallback([
            http(vcityNetwork.rpcUrls.default.http[0], {
                timeout: 10000, // 延长超时时间，避免本地节点响应慢导致连接失败
            }),
        ]),
    },

    // 禁用所有可能干扰本地连接的配置
    ssr: false,
    // multiInjectedProviderDiscovery: false,
    syncConnectedChain: true, // 强制同步钱包当前链

    // 全局事件回调
    onConnect({ connector, account, chain }) {},
    onDisconnect() {},
    onAccountsChanged({ accounts }) {},
    onChainChanged({ chain }) {},
});

declare module 'wagmi' {
    interface Register {
        config: typeof config;
    }
}
